/**
 * CodesMappedGraph component module.
 * @module shared/components/CodesMappedGraph
 *
 */
import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import Pie from '../../../../shared/components/graphs/Pie';
import {_openModal} from '../../../../shared/reducers/modals';
import {connect} from 'react-redux';
import {getColorListPrimary, getColor} from '../../../../shared/utils/colors';
import {getCounts} from '../../../../shared/utils/containerUtils';
import history from '../../../../history';
import qs from 'query-string';
import {LoadingSpinner} from '../../../../shared';
import Row from '../../../../shared/components/Row';

const CodesMappedGraph = ({session, openModal}) => {
  const colorList = [...getColorListPrimary()];

  const {data: swrCounts} = getCounts({
    session: session,
    options: {onError: err => openModal({type: 'Error', title: 'Codes Mapped to Advisors', err})},
  });

  const formattedData = useMemo(() => swrCounts
    && (swrCounts.codes && swrCounts.codes.total
      ? [
        {
          id: 1,
          name: 'Mapped',
          color: getColor(colorList),
          y: swrCounts.codes.mapped,
        },
        {
          id: 0,
          name: 'Unmapped',
          color: getColor(colorList),
          y: swrCounts.codes.unmapped,
        },
      ]
      : [{name: 'No Codes', color: '#797B83', y: 1}]), [swrCounts]);

  if (!formattedData) {
    return <LoadingSpinner/>;
  }

  return <Row height={'100px'}
              alignSubRow={'stretch'}
              alignItems={'stretch'}
              layout={{grow: 1}}>
    <Pie data={formattedData}
         sliceAction={slice => history.push(`/manage/codes?${qs.stringify({
           filters: btoa(JSON.stringify({
             isMapped: {
               label: `${slice.name} Codes`,
               value: slice.id,
             },
           })),
         })}`)}
         centerAction={() => history.push('/manage/codes')}
    />
  </Row>;
};

const mapDispatchToProps = (dispatch) => ({
  openModal: modalToOpen => dispatch(_openModal(modalToOpen)),
});

export default connect(null, mapDispatchToProps)(CodesMappedGraph);

CodesMappedGraph.propTypes = {
  openModal: PropTypes.func,
  session: PropTypes.object,
};
